// TODO: create support for multiple OCP's
export default ({ hash = '', initOpen = false } = {}) => {
  return {
    data () {
      return {
        isOcpOpen: initOpen
      }
    },
    beforeDestroy () {
      window.removeEventListener('hashchange', this.onHashChange)
    },
    created () {
      if (process.client) {
        if (window.location.hash === `#${hash}`) {
          setTimeout(() => {
            this.toggleOCP(true)
          }, 100)
        }

        window.addEventListener('hashchange', this.onHashChange)
      }
    },
    methods: {
      toggleOCP (isOpen) {
        this.toggleHash(isOpen)
        this.isOcpOpen = isOpen
      },
      onHashChange () {
        this.isOcpOpen = window.location.hash === `#${hash}`
      },
      toggleHash (isActive) {
        const routerBase = process.env.ROUTER_BASE.length > 1 ? process.env.ROUTER_BASE : ''

        if (isActive) {
          /* push new state to history so ocp can be closed with back button,
          use replace when opening ocp from another ocp */
          const historyMethod = window.location.hash === `#${hash}` ? 'replaceState' : 'pushState'
          window.history[historyMethod]({ id: hash }, hash, `${routerBase}${this.$router.currentRoute.fullPath.replace(`${this.$router.currentRoute.hash}`, '').replace(`#${hash}`, '')}#${hash}`)
        } else {
          window.history.pushState({ id: '' }, '', `${routerBase}${this.$router.currentRoute.fullPath.replace(`#${hash}`, '')}`)
        }
      }
    }
  }
}
